import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Header = styled.header`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  z-index: 1011;
  padding: 10px;
  text-align: center;
  pointer-events: none;

  a {
    color: inherit;
    margin-left: 10px;
  }
`;

export const PreviewBanner: FC<any> = ({ customerName }) => {
  const intl = useIntl();

  return (
    <Header data-cy="customer-preview.banner">
      <span>
        {intl.formatMessage(
          {
            id: 'projects.preview.banner.title',
          },
          {
            company_name: customerName,
          },
        )}
      </span>
      {/* <a onClick={() => close()}><b><u>Exit the view</u></b></a> */}
    </Header>
  );
};
